<div *ngFor="let modal of modalList" appAutoFocus>

  <!-- standard modal -->
  <section class="modal modal--{{modal.type}} ammendError" *ngIf="modal.modalType === 'standard'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title"><i class="icon" *ngIf="modal.type === 'danger'">alert</i>{{modal.title}}</h4>
        </div>
        <div class="modal-body" [innerHtml]="modal.content">
        </div>
        <div class="modal-footer clearfix" *ngIf="modal.routerLink">
          <a id="modal-submit" class="{{modal.buttonClass}}" routerLink="/{{modal.routerLink}}"
            (click)="removeClasses()">
            {{modal.buttonText}}
          </a>
        </div>
        <div class="modal-footer clearfix" *ngIf="modal.buttonLink">
          <a id="modal-submit" class="{{modal.buttonClass}}" href="{{modal.buttonLink}}" target="_blank"
            (click)="removeClasses()">
            {{modal.buttonText}}
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- standard modal - no close -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'standardNoClose'">

    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <!--<button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>-->
          <h4 class="modal-title"><i class="icon" *ngIf="modal.type === 'danger'">alert</i>{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <p class="text-muted">{{modal.content}}</p>
        </div>
        <div class="modal-footer clearfix" *ngIf="modal.routerLink">
          <button type="button" class="btn btn-primary btn-lg btn-block" (click)="goToQuote()">
            Search again
          </button>
          <div class="hr-text text-center text-muted margin-top-8 margin-bottom-8">
            <span>or</span>
          </div>
          <a id="modal-submit" class="{{modal.buttonClass}}" routerLink="/{{modal.routerLink}}"
            (click)="removeClasses()">
            {{modal.buttonText}}
          </a>
        </div>

        <div class="modal-footer clearfix" *ngIf="modal.buttonLink">
          <button type="button" class="btn btn-primary btn-lg btn-block" (click)="goToQuote()">
            Search again
          </button>
          <div class="hr-text text-center text-muted margin-top-8 margin-bottom-8">
            <span>or</span>
          </div>
          <a id="modal-submit" class="{{modal.buttonClass}}" href="{{modal.buttonLink}}" target="_blank"
            (click)="removeClasses()">
            {{modal.buttonText}}
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- resend booking email -->
  <section class="modal mmbv2 modal--{{modal.type}}" *ngIf="modal.modalType === 'resendConfirm'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h3 class="modal-title">{{modal.title}}</h3>
        </div>
        <div class="modal-body btn-action">
          <button class="btn btn__outlined-red width-100" (click)="closeModal($event)">
            <span>
              {{this.appCopy.panelHeader['cancelButton' + this.selectedLanguage]}}
            </span>
          </button>
          <button class="btn btn__purple width-100" [disabled]="showLoader" (click)="resendClickHandler()">
            <span>{{this.appCopy.panelHeader['resendEmailBookingButton' + this.selectedLanguage]}}</span>
            <div class="loader-container-btn" *ngIf="showLoader">
              <div class="loader loader--white">
                <svg class="circular" viewBox="25 25 50 50">
                  <circle class="path" cx="50" cy="50" r="20" />
                </svg>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </section>
  <!-- delete complete booking modal -->
  <section class="modal mmbv2 modal--{{modal.type}}" *ngIf="modal.modalType === 'deleteBooking'">
    <div class="modal-dialog">
      <form #formCancelReason="ngForm" class="modal-content" mame="formCancelReason" id="formCancelReason"
        (ngSubmit)="submitCancelReason()" novalidate>
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <!-- <p class="text-muted">{{modal.content}}</p> -->
          <!-- <div class="get-in-touch">
            <div class="flex">
              <div class="flex margin-right-16">
                <img class="margin-right-16" src="./images/modal/modal_life-ring-telephone.svg" alt="">
                <a href="tel:+442033846677">+44 203 384 6677</a>
              </div>
              <button type="button" class="btn btn-sm btn-chat" (click)="handleChatClick()">{{ appCopy.panelHeader['liveChatText' + selectedLanguage] }}</button>
            </div>
          </div> -->
          <h4>{{ appCopy.panelHeader['helpUsUnderstandText' + selectedLanguage] }}</h4>
          <p>{{ appCopy.panelHeader['whyYouWantToCancelBookingText' + selectedLanguage] }}</p>
          <div *ngFor="let reason of cancelReasons; let i = index;">
            <div class="radio radio--default radio--small">
              <div class="reason-{{i}}">
                <input type="radio" name="cancelReason" id="reason{{i}}" [(ngModel)]="cancelReasonSelected" [value]="i"
                  required>
                <label for="reason{{i}}">{{ appCopy.panelHeader[reason + selectedLanguage] }}</label>
              </div>
            </div>
          </div>
          <div class="form-group cancelReasonCustom" *ngIf="cancelReasonSelected === cancelReasons.length - 1">
            <input class="form-control form-control--no-label" [ngClass]="{ 'has-error' : cityInvalid, 'has-error': cancelReasonCustom.length > 500 }"
            id="cancelReasonCustom" name="cancelReasonCustom" placeholder="{{appCopy.panelHeader['otherReasonPlaceholder'+selectedLanguage]}}" [(ngModel)]="cancelReasonCustom"
            required>
            <p class="help-block text-danger" *ngIf="cancelReasonCustom.length > 500">{{ appCopy.panelHeader['invalidCancelReason'+selectedLanguage] }}</p>
          </div>
        </div>
        <div class="modal-footer ">
          <div class="btn-action">
          <button *ngIf="!cancelReasonSubmitted" type="submit" [disabled]="cancelReasonSelected === i || cancelReasonSelected === null" class="btn btn__outlined"
                [disabled]="formCancelReason.invalid || cancelReasonCustom.length > 500">
                {{modal.buttonText}}
              </button>
          <!-- (cancelReasonSubmitted && modal.flightData[0].airlineCode !== 'BA') -->
          <div class="modal-cancel-confirmation width-100"
            *ngIf="(cancelReasonSubmitted && cancelReasonSelected !== 0) || cancelReasonSubmitted">
            <p [innerHTML]="appCopy.panelHeader['confirmChoiceText'+selectedLanguage]"></p>
              <div class="btn-action">
                <button type="button" class="btn btn__purple width-100" (click)="closeModal($event)">
                  {{ appCopy.panelHeader['keepMyBookingButton'+selectedLanguage] }}
                </button>
                <button type="button" class="btn btn__red width-100"
                  (click)="deleteBooking(formCancelReason.value, modal.bookingReference, modal.bookingJourneyReference, modal.userToken)">
                  {{ appCopy.panelHeader['cancelMyBookingButton'+selectedLanguage] }}
                </button>
              </div>
            </div>
            <!-- <a class="link link--gray" href="javascript:void(0)" (click)="resetReasons()">{{ appCopy.panelHeader['chooseDifferentOptionLink'+selectedLanguage] }}</a> -->
          </div>

          <!-- *ngIf="cancelReasonSubmitted && cancelReasonSelected === 0 && modal.flightData[0].airlineCode === 'BA'" -->
          <div class="modal-cancel-confirmation margin-top-24" style="display: none;">
            <img class="margin-bottom-12" src="./images/modal/modal_ba_logo.svg" alt="">
            <p [innerHTML]="appCopy.panelHeader['boardingPassNotNeededBAText'+selectedLanguage]"></p>
            <ul>
              <li class="row">
                <div class="col-xs-2 col-sm-1">
                  <img src="./images/modal/modal_tick.svg" alt="">
                </div>
                <div class="col-xs-10 col-sm-11">
                  <p [innerHTML]="appCopy.panelHeader['checkInOnlineBAText'+selectedLanguage]"></p>
                </div>
              </li>
              <li class="row">
                <div class="col-xs-2 col-sm-1">
                  <img src="./images/modal/modal_tick.svg" alt="">
                </div>
                <div class="col-xs-10 col-sm-11">
                  <p>{{ appCopy.panelHeader['visaChildrenNoProblemText'+selectedLanguage] }}</p>
                </div>
              </li>
              <li class="row">
                <div class="col-xs-2 col-sm-1">
                  <img src="./images/modal/modal_tick.svg" alt="">
                </div>
                <div class="col-xs-10 col-sm-11">
                  <p>{{ appCopy.panelHeader['directLinkWithBASystemText'+selectedLanguage] }}</p>
                </div>
              </li>
            </ul>
            <div class="row margin-bottom-12">
              <div class="col-sm-8">
                <button type="button" class="btn btn-primary btn-block" (click)="closeModal($event)">
                  {{ appCopy.panelHeader['GreatKeepMyBookingButton'+selectedLanguage] }}
                </button>
              </div>
            </div>
            <a class="link link--gray" href="javascript:void(0)" (click)="resetReasons()">{{ appCopy.panelHeader['chooseDifferentOptionLink'+selectedLanguage] }}</a>
            {{ appCopy.panelHeader['orText'+selectedLanguage] }}
            <a class="link link--gray" href="javascript:void(0)"
              (click)="deleteBooking(formCancelReason.value, modal.bookingReference, modal.bookingJourneyReference, modal.userToken)">{{ appCopy.panelHeader['cancelAnyWayLink'+selectedLanguage] }}</a>
          </div>
        </div>
      </form>
    </div>
  </section>

  <!-- incorrect flight direction modal -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'flightDirection'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <!--<button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>-->
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <p class="text-muted">{{modal.content}}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-lg btn-block" (click)="goToQuote()">
            Search again
          </button>
          <div class="hr-text text-center text-muted margin-top-8 margin-bottom-8">
            <span>or</span>
          </div>
          <button type="button" class="btn btn-primary btn-ghost btn-lg btn-block" (click)="continueBooking()">
            {{ modal.buttonText }}
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- incorrect flight direction modal -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'flightNoService'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <!--<button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>-->
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <p class="text-muted" [innerHtml]="modal.content"></p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-lg btn-block" (click)="goToQuote()">
            Search again
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- admin filters modal -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'adminFilters'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <form name="formAdminFilters" novalidate>
            <app-admin-filters [appCopy]="appCopy" [selectedLanguage]="selectedLanguage"
              [filtersSelected]="filtersSelected" (appliedFilters)="filterFormValues($event)">
            </app-admin-filters>
          </form>
          <p class="help-block text-danger" *ngIf="showDateError">{{ appCopy.panelHeader['errorFilterDateInvalid'+selectedLanguage] }}</p>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6">
              <button type="button" class="btn btn-primary btn-ghost btn-block"
                (click)="clearFilters($event); closeModal($event)">{{ appCopy.panelHeader['clearAllFiltersButton'+selectedLanguage] }}</button>
            </div>
            <div class="col-sm-6">
              <button type="button" (click)="setAdminFilters($event)" class="btn btn-primary btn-block"
                [disabled]="filtersDisabled">
                {{ modal.buttonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- flight not listed -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'flightNotListed'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <p class="text-muted">{{modal.content}}</p>
          <button type="button" class="btn btn-primary btn-lg btn-block" (click)="showFlightSearch('flightNumber')">
            Enter my Flight Number
          </button>
        </div>
        <div class="modal-footer text-primary bg-primary-light padding-top-16">
          <p>Or you could use Airport Delivery</p>
          <hr class="margin-top-16 margin-bottom-16">
          <div class="media margin-bottom-16">
            <div class="media-left media-middle">
              <i class="spritre sprite--product-airport"></i>
            </div>
            <div class="media-body media-middle">
              <h5 class="margin-top-0 margin-bottom-0">We deliver your bags to the airport</h5>
              <p>You collect them from us before checking in</p>
            </div>
          </div>
          <button type="button" class="btn btn-primary btn-ghost btn-lg btn-block"
            (click)="goToSDSFlightSearch($event)">
            Book Airport Delivery
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- delete card modal -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'deleteCard'">
    <div class="modal-dialog w-500">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <p class="text-muted">{{modal.content}}</p>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6">
              <button type="button" class="btn btn-primary btn-lg btn-block" (click)="closeModal($event)">{{
                modal.cancelButtonText }}</button>
            </div>
            <div class="col-sm-6">
              <button type="submit" class="btn btn-danger btn-lg btn-block" [disabled]="isDisabled"
                (click)="deleteCard(modal.cardReference, modal.userId, modal.userToken)">
                {{ modal.buttonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- miles relogin confirmation -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'milesRelogin'">
    <div class="modal-dialog w-500">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <p>{{modal.content}}</p>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6">
              <button type="button" class="btn btn-default btn-lg btn-block" (click)="closeModal($event)">{{
                modal.cancelButtonText }}</button>
            </div>
            <div class="col-sm-6">
              <button type="submit" class="btn btn-purple btn-lg btn-block" [disabled]="isDisabled"
                (click)="milesLoginRedirect()">
                {{ modal.buttonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

    <!--priceBreakdown -->
    <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'priceBreakdown'">
      <div class="modal-dialog w-500">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
            <h4 class="modal-title text-dark-blue" >{{appCopyModal.panelHeader['priceBreakdownTitle'+this.selectedLanguage] }}</h4>
          </div>
          <div class="modal-body">
            <div class="grid gap-8">
              <ng-container *ngIf="modal.priceBreakdown.isD2dService; then d2d; else notD2d"></ng-container>

              <ng-template #d2d>
                <div *ngIf="modal.priceBreakdown.basePriceDep > 0" class="flex-always flex--space-between">
                  <div>
                    <p>{{appCopyModal.panelHeader['basePriceDep'+selectedLanguage]}}</p>
                  </div>
                  <p class="discount-price">
                    {{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
                    :''}}{{modal.priceBreakdown.basePriceDep}}
                  </p>
                </div>

                <div *ngIf="modal.priceBreakdown.basePriceArrival > 0" class="flex-always flex--space-between">
                  <div>
                    <p>{{appCopyModal.panelHeader['basePriceArrival'+selectedLanguage]}}</p>
                  </div>
                  <p class="discount-price">
                    {{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
                    :''}}{{modal.priceBreakdown.basePriceArrival}}
                  </p>
                </div>

                <div class="flex-always flex--space-between" *ngIf="modal.priceBreakdown.oversizeItemSurcharge > 0">
                  <div>
                    <p>{{appCopyModal.panelHeader['oversizeItemSurcharge'+selectedLanguage]}}</p>
                  </div>
                  <p class="discount-price">{{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? '
                    ' :''}}{{modal.priceBreakdown.oversizeItemSurcharge}}</p>
                </div>

                <div *ngIf="modal.priceBreakdown.sbbDiscountDep > 0" class="flex-always flex--space-between">
                  <div>
                    <p>{{appCopyModal.panelHeader['sbbDiscountDep'+selectedLanguage]}}</p>
                  </div>
                  <p class="discount-price">
                    ({{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
                    :''}}{{modal.priceBreakdown.sbbDiscountDep}})
                  </p>
                </div>

                <div *ngIf="modal.priceBreakdown.sbbDiscountArrival > 0" class="flex-always flex--space-between">
                  <div>
                    <p>{{appCopyModal.panelHeader['sbbDiscountArrival'+selectedLanguage]}}</p>
                  </div>
                  <p class="discount-price">
                    ({{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' ' :''}}
                    {{modal.priceBreakdown.sbbDiscountArrival}})
                  </p>
                </div>

              </ng-template>

              <ng-template #notD2d>

                <div class="flex-always flex--space-between" *ngIf="modal.priceBreakdown.basePrice > 0">
                  <div>
                    <p>{{appCopyModal.panelHeader['basePrice'+selectedLanguage]}}</p>
                  </div>
                  <p class="discount-price">{{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? '
                    ' :''}}{{modal.priceBreakdown.basePrice}}</p>
                </div>

                <div class="flex-always flex--space-between" *ngIf="modal.priceBreakdown.oversizeItemSurcharge > 0">
                  <div>
                    <p>{{appCopyModal.panelHeader['oversizeItemSurcharge'+selectedLanguage]}}</p>
                  </div>
                  <p class="discount-price">{{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? '
                    ' :''}}{{modal.priceBreakdown.oversizeItemSurcharge}}</p>
                </div>

                <div *ngIf="modal.priceBreakdown.sbbDiscount > 0" class="flex-always flex--space-between">
                  <div>
                    <p>{{appCopyModal.panelHeader['sbbDiscount'+selectedLanguage]}}</p>
                  </div>
                  <p class="discount-price">
                    ({{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
                    :''}}{{modal.priceBreakdown.sbbDiscount}})
                  </p>
                </div>

              </ng-template>

              <div class="flex-always flex--space-between" *ngIf="modal.priceBreakdown.promoCodesApplied !== null">
                <div>
                  <p>{{appCopyModal.panelHeader['discount'+selectedLanguage]}} ({{modal.priceBreakdown.promotionRewardType === 2 ?
                    modal.priceBreakdown.promotionRewardAmount+'%' : modal.priceBreakdown.currencySymbol +
                    (modal.priceBreakdown.promotionRewardAmount /
                    100)}})</p>
                </div>
                <p class="discount-price">({{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
                  :''}}{{modal.priceBreakdown.discount}})</p>
              </div>

              <div class="flex-always flex--space-between" *ngIf="modal.priceBreakdown.milesDiscountApplied">
                <div>
                  <p>{{appCopyModal.panelHeader['milesDiscount'+selectedLanguage]}}</p>
                </div>
                <p class="discount-price">({{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
                  :''}}{{modal.priceBreakdown.milesDiscountedPrice}})</p>
              </div>

            </div>
          </div>
          <div class="modal-footer">

            <div class="flex-always flex--space-between">
              <div class='text-primary'>
                <p>{{appCopyModal.panelHeader['total'+selectedLanguage]}}</p>
              </div>
              <p class="text-primary">{{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' ' :''}}{{modal.priceBreakdown.total}} </p>
            </div>

          </div>
        </div>
      </div>
    </section>


  <app-remove-service-modal
    *ngIf="modal.modalType === 'removeService'"
    [modalData]="modal">
  </app-remove-service-modal>

  <app-modal-time-slot-expired
    *ngIf="modal.modalType === 'timeSlotExpried'"
    [modalData]="modal">
  </app-modal-time-slot-expired>

    <!-- savePereferences modal -->
    <section class="modal modal--savePereferences modal--{{modal.type}}" *ngIf="modal.modalType === 'savePereferences'">
      <div class="modal-dialog w-500">
        <div class="modal-content">
          <div class="modal-header">
            <!-- <button type="button" class="close" (click)="closeModal($event, 'savePereferences')"><i class="icon">cross</i></button> -->
            <h4 class="modal-title">{{appCopyModal.panelHeader['preferenceTitle'+selectedLanguage]}}</h4>
          </div>
          <div class="modal-body">
            <form #form="ngForm" name="formBooker" (ngSubmit)="handleSavePreferencesSubmit()" novalidate>


            <div class="form-group">
              <input class="form-control"
                [ngClass]="{ 'has-error' : bookerEmail.dirty && bookerEmail.invalid || bookerEmail.dirty && bookerEmail.errors?.pattern || bookerEmail.errors?.incorrect }"
                id="bookerEmail" name="bookerEmail" type="email" #bookerEmail="ngModel" (ngModelChange)="verifiyAccount(bookerEmail.value)" [(ngModel)]="bookerData.emailAddress"
                [readonly]="userLoggedIn && (bookingType !== 'amend' || !user.userDetails.userPermissions.showAdminFeatures)"
                (blur)="verifiyAccount(bookerEmail.value)" autocomplete="off" required appCheckEmpty>
              <label class="control-label"
                for="bookerEmail">{{appCopyModal.panelHeader['bookerEmailLabel'+selectedLanguage]}}</label>
              <i class="icon control-validation-state"></i>

              <p class="help-block text-danger"
                *ngIf="bookerEmail.dirty && bookerEmail.invalid && !bookerEmail.errors?.pattern || bookerEmail.errors?.incorrect">
                {{appCopyModal.panelHeader['errorTextBookerEmailRequired'+selectedLanguage]}}</p>
              <p class="help-block text-danger" *ngIf="bookerEmail.dirty && bookerEmail.errors?.pattern">
                {{appCopyModal.panelHeader['errorTextBookerEmailInvalid'+selectedLanguage]}}</p>
            </div>
            <div class="form-group multiple-inputs clearfix">
              <div class="row">
                <div class="col-xs-12">
                  <div class="col-xs-2 col-sm-2 with-select">
                    <div class="with-select__custom-value">+{{contactCountryCode.value}}</div>
                    <ng-select class="form-control form-control--no-label"
                      [ngClass]="{ 'has-error' : contactPhone.errors?.incorrect || contactPhone.invalid && contactPhone.dirty }"
                      id="contactCountryCode" name="contactCountryCode" #contactCountryCode="ngModel"
                      [(ngModel)]="bookerData.countryCode" (ngModelChange)="validatePhoneNumber($event, contactPhone.value)"
                      [clearable]="false"
                      [items]="countryCodes.all" [notFoundText]="appCopyModal.panelHeader['bookerCountryNotFound'+selectedLanguage]" groupBy="label" bindLabel="displayText" bindValue="countryCode"
                      >

                    </ng-select>
                  </div>
                  <div class="col-xs-10 col-sm-10 padding-right-0 padding-left-0">
                    <input class="form-control form-control--no-label"
                      [ngClass]="{ 'has-error' : contactPhone.invalid && contactPhone.dirty || contactPhone.errors?.incorrect }"
                      type="number" id="contactPhone" name="contactPhone" #contactPhone="ngModel"
                      placeholder="{{appCopyModal.panelHeader['contactPlaceholder'+selectedLanguage]}}"
                      [(ngModel)]="bookerData.phoneNumber" (ngModelChange)="validatePhoneNumber(contactCountryCode.value, contactPhone.value)"
                      (blur)="validatePhoneNumber(contactCountryCode.value, contactPhone.value)" required appCheckEmpty>
                    <i class="icon control-validation-state"></i>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <p class="help-block text-danger"
                    *ngIf="contactPhone.invalid && contactPhone.dirty || contactPhone.errors?.incorrect">
                    {{appCopyModal.panelHeader['errorTextContact'+selectedLanguage]}}</p>
                </div>
              </div>
            </div>
            <div class="message">{{appCopyModal.panelHeader['preferenceMsg'+selectedLanguage]}}</div>
            <div class="checkbox checkbox--default checkbox--small checkbox--reverse margin-bottom-16 hasSmsMarketingEnrolment">
              <input type="checkbox" checked="true" name="hasSmsMarketingEnrolment" id="hasSmsMarketingEnrolment"
                #HasSmsMarketingEnrolment="ngModel" [ngModel]='true'>
              <label for="hasSmsMarketingEnrolment" class="text-caption">
                <span>
                  <b>{{appCopyModal.panelHeader['hasSmsMarketingEnrolmentCheckLabel'+selectedLanguage]}}</b>
                  <span>{{appCopyModal.panelHeader['hasSmsMarketingEnrolmentChecMsg'+selectedLanguage]}}</span>
                </span>
              </label>
            </div>

            <!-- <div
              class="checkbox checkbox--default checkbox--small checkbox--reverse margin-bottom-16">
              <input type="checkbox" name="optOutMarketingEnrolment" id="optOutMarketingEnrolment"
                #optOutMarketingEnrolment="ngModel" [ngModel]="false">
              <label for="optOutMarketingEnrolment" style="color:#00005A;"
                class="text-caption">{{appCopyModal.panelHeader['optOutMarketingEnrolmentCheckLabel'+selectedLanguage]}}</label>
            </div> -->
            <div class="row">
              <div class="col-sm-12">
                <button [disabled]="buttonDisabled" type="submit" class="btn btn-primary btn-lg btn-block">
                  {{!dataChanged ? appCopyModal.panelHeader['confirm'+selectedLanguage] : appCopyModal.panelHeader['savePreferences'+selectedLanguage]}}
                </button>
              </div>
            </div>
          </form>
          </div>
        </div>
      </div>
    </section>

  <div class="modal-backdrop"></div>
</div>
